<template lang="html">

  <div class="">
    <div class="twoColumnGrid">

      <tl-select class="ht-35" labelText="name" label="Loan Type" :options="loanTypesArray" :value="formData.loanType" :reduce="loanObj => loanObj.name"
        @change="(val)=>formData.loanType=val"></tl-select>
      <txt autofocus="autofocus" label='Loan Amount' type="number" v-model='formData.loan_amount' name="loan_amount" placeholder=""
        v-validate="'required'" :classname="errors.has('loan_amount')" :errormsg="errors.first('loan_amount')">
      </txt>
      <div class="max-width-300">
        <span class="feild-label">Loan Description</span>
        <textarea class="form-control width-100 margin-top-5" v-model="formData.loanDescription"></textarea>
      </div>

      <div class="max-width-300">
        <span class="feild-label">Disbursement Date</span>
        <date-picker class="ht-35 margin-top-5" @datevalue="(val)=>formData.disbursement_date=val" :value="formData.disbursement_date"
          v-model="formData.disbursement_date" :formatDate="'dd-MM-yyyy'" />
      </div>

      <div class="max-width-300">
        <span class="feild-label">Repayment Start Date</span>
        <date-picker class="ht-35 margin-top-5" @datevalue="(val)=>formData.repayment_date=val" :value="formData.repayment_date"
          v-model="formData.repayment_date" :formatDate="'dd-MM-yyyy'" />
      </div>
      <txt autofocus="autofocus" label='Opening Balance' type="number" v-model='formData.opening_balance' name="opening_balance"
        placeholder="" v-validate="'required'" :classname="errors.has('opening_balance')" :errormsg="errors.first('opening_balance')">
      </txt>
      <div>
        <tl-select class="max-width-300" label="Interest Type" :value="formData.interestType" :options="interestTypesArray" @change="(val)=>changeInterestType(val)"
        />
      </div>
      <div>
        <tl-select class="max-width-300" label="Recovery Type" :value="formData.recoveryType" :options="interestTypesArray" @change="(val)=>changeInterestType(val)"
        />
      </div>
      <txt autofocus="autofocus" label='No of Installments' type="number" v-model='formData.no_of_installments' name="no_of_installments"
        placeholder="" v-validate="'required'" :classname="errors.has('no_of_installments')" :errormsg="errors.first('no_of_installments')">
      </txt>
      <txt autofocus="autofocus" label='Rate of Interest' type="number" v-model='formData.rate_of_interest' name="rate_of_interest"
        placeholder="" v-validate="'required'" :classname="errors.has('rate_of_interest')" :errormsg="errors.first('rate_of_interest')">
      </txt>
      <div>
        <tl-select class="max-width-300" label="Round of values" :value="formData.roundOffValues" :options="interestTypesArray" @change="(val)=>changeInterestType(val)"
        />
      </div>
      <txt autofocus="autofocus" label='No of months paid' type="number" v-model='formData.no_of_months_paid' name="no_of_months_paid"
        placeholder="" v-validate="'required'" :classname="errors.has('no_of_months_paid')" :errormsg="errors.first('no_of_months_paid')">
      </txt>
    </div>

    <div class="margin-top-36">
      <btn class="custom-btn" text="Payment Schedule" type="secondary" @click="repaymentSchedule()" />
    </div>

    <div v-if="isFormValidated">

      <div class="margin-top-40">

        <data-table :columns="columnNames" :tableData="paymentScheduleData" :checkbox="false" :withForm="false" :showinrow="false">
          <template v-slot:rowcontent="slotprops">

            <!-- dropdown section starts here -->
            <div class="action-section" v-if="slotprops.value.column.key=='action'">
              <img src="@/assets/group-2.png" @click="dropdown(slotprops.value)" alt="actionIcon">
              <ul class="action-menu" v-show="paymentScheduleData[slotprops.value.index].showDropdown">
                <li>
                  <span class="">Change ESS Status </span>
                </li>
                <li>
                  <span class="">Reset ESS Password </span>
                </li>
                <li>
                  <span class="">Create ESS Login </span>
                </li>
              </ul>
            </div>
            <!-- dropdown section ends here -->
          </template>
        </data-table>

      </div>

      <div class="margin-top-20">
        <div class="customTwoColumnGrid">
          <txt class="" autofocus="autofocus" label='Total Principal' type="number" v-model='formData.totalPrinciple' name="totalPrinciple"
            placeholder="" v-validate="'required'" :classname="errors.has('totalPrinciple')" :errormsg="errors.first('totalPrinciple')">
          </txt>
          <txt class="" autofocus="autofocus" label='Total Interest' type="number" v-model='formData.totalInterest' name="totalInterest"
            placeholder="" v-validate="'required'" :classname="errors.has('totalInterest')" :errormsg="errors.first('totalInterest')">
          </txt>
          <txt class="" autofocus="autofocus" label='Total Amount Due' type="number" v-model='formData.totalAmountDue' name="totalAmountDue"
            placeholder="" v-validate="'required'" :classname="errors.has('totalAmountDue')" :errormsg="errors.first('totalAmountDue')">
          </txt>
        </div>
      </div>
    </div>


    <bottom-action-container >
      <template slot="end">
        <btn-grp>
          <btn text="Back" type="secondary" @click="goBack" />
          <btn text="Save" :disabled="!isTotalFormValidated" type="primary" @click="save" />
        </btn-grp>
      </template>
    </bottom-action-container>

  </div>
</template>

<script>
  import { mapState, mapGetters, mapActions } from "vuex";

  export default {
    name: "loanPerk",
    computed: {
      ...mapState({}),
      ...mapGetters({
        orgid: "onboard/organization/orgid"
      })
    },
    data() {
      return {
        formData: {
          loan_amount: "",
          opening_balance: "",
          no_of_installments: "",
          rate_of_interest: "",
          no_of_months_paid: "",

          loanDescription: "",

          loanType: "",
          disbursement_date: "",
          repayment_date: "",
          interestType: "",
          recoveryType: "",
          roundOffValues: "",

          totalPrinciple: "",
          totalInterest: "",
          totalAmountDue: "",

          employee_code_name: "",
          loan_name: "",

          changedPrinciple: "",
          changedInterest: "",
          pendingPrinciple: "",
          pendingInterest: ""
        },

        isFormValidated: false,
        isTotalFormValidated: true,
        interestTypesArray: ["Interest 1", "Interest 2"],
        loanTypesArray: [
          { id: 1, name: "L 1" },
          { id: 2, name: "L 2" },
          { id: 3, name: "L 3" },
          { id: 4, name: "L 4" }
        ],

        columnNames: [
          {
            label: "Sl.No",
            key: "slno"
          },
          {
            label: "Schedule Date",
            key: "scheduleDate"
          },
          {
            label: "Principal Amount",
            key: "principalAmount"
          },
          {
            label: "Interest",
            key: "interest"
          },
          {
            label: "EMI",
            key: "emi"
          },
          {
            label: "Actions",
            key: "action"
          }
        ],

        paymentScheduleData: [
          {
            id: 1,
            slno: "1",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 2,
            slno: "2",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 3,
            slno: "3",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 4,
            slno: "4",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 5,
            slno: "4",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 6,
            slno: "4",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 7,
            slno: "4",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 8,
            slno: "4",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          },
          {
            id: 9,
            slno: "4",
            scheduleDate: "23 Jun 2019",
            principalAmount: "0",
            interest: "0",
            perquisite: "0",
            emi: "0",
            action: "",
            showDropdown: false
          }
        ]
      };
    },
    mounted() { },

    methods: {
      ...mapActions({}),

      repaymentSchedule() {
        this.$validator.validateAll().then(result => {
          if (result) {
            //console.log("result:", result);
            this.isFormValidated = true;
          } else {
            this.isFormValidated = false;
          }
        });
      },

      apply() { },

      dropdown(slots) {
        let idx = this.paymentScheduleData.findIndex(obj => {
          return obj.id == slots.index + 1;
        });
        this.paymentScheduleData.forEach((data, index) => {
          if (index != idx) {
            data.showDropdown = false;
          }
        });
        if (idx > -1) {
          this.paymentScheduleData[slots.index].showDropdown = !this.paymentScheduleData[slots.index].showDropdown;
        }
      },

      nextInstallment(record) {
        //console.log("nextInstallment:", record);
      },

      lastInstallment(record) {
        //console.log("nextInstallment:", record);
      },

      additionalMonth(record) {
        //console.log("nextInstallment:", record);
      },

      goBack() {this.$router.go(-1)  },

      save() {this.$router.go(-1)  }
    }
  };
</script>

<style lang="scss" scoped>
  .bottom-padding-20 {
    padding: 0px 0px 20px;
  }

  .max-width-300 {
    max-width: 300px;
  }

  .top-padding-20 {
    padding: 20px 0px 0px;
  }

  .margin-top-5 {
    margin-top: 5px;
  }

  .margin-top-36 {
    margin-top: 3.6%;
  }

  .loanStatus-text {
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    color: #6e6e6e;
  }

  .red-color {
    color: #e02020;
  }

  .green-color {
    color: #34c0be;
  }

  .padding-10 {
    padding: 10px 0px;
  }

  .empl-fbp-table {
    .particular-table {
      background-color: #f9f9f9;
      width: 100%;
      border-collapse: collapse;
      th,
      td {
        padding: 10px;
      }
      thead {
        th {
          border-bottom: 2px solid #34c0be;
        }
      }
      .tableInput {
        width: 50%;
      }
    }
  }

  .modal-table {
    max-height: 300px;
    height: auto;
    overflow: auto;
    tbody {
      max-height: 200px;
      overflow-y: auto;
    }
  }

  .modal-body {
    overflow-y: auto;
  }

  .column-header {
    opacity: 0.42;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    color: #000000;
  }

  .row-data {
    font-family: Montserrat;
    font-size: 14px;
    color: #000000;
  }

  .height-54 {
    height: 54px;
  }

  .action-section {
    margin: 0px;
    text-align: left;

    img {
      width: auto;
    }
    .action-menu {
      top: 0px;
      right: 54px;
      left: -215px;
      li {
        padding: 0px;
        padding: 10px 25px;
        font-weight: 500;
        &:not(:last-child) {
          border-bottom: solid 1px #97979759;
        }
      }
    }
  }

  .margin-top-40 {
    margin-top: 40px;
  }

  .margin-top-20 {
    margin-top: 20px;
  }

  .margin-top-50 {
    margin-top: 50px;
  }

  .max-width-200 {
    max-width: 200px;
  }

  .empl-fbp-table .particular-table thead th {
    background-color: #f0f1f5;
    border-bottom: 1px solid #34c0be;
    padding: 18px;
  }

  .empl-fbp-table .particular-table td {
    padding: 18px;
    width: 10%;
  }

  .content-center {
    justify-content: flex-center;
  }

  .modal-header-text {
    opacity: 0.42;
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 600;
    color: #000000;
  }

  .custom-modal .modal-content.modal-sm {
    width: 700px;
  }

  .custom-modal .modal-content .modal-body {
    padding: 14px 32px 16px;
  }

  .modal-bottom-container {
    justify-content: center;
    display: flex;
  }

  .closeBtn {
    margin-right: 10px;
  }

  .applyBtn {
    margin-left: 10px;
  }

  .height-40 {
    height: 40px;
  }

  .tl-select-dropdown {
    margin-bottom: 0px;
  }

  .feild-label {
    font-family: Montserrat;
    font-size: 12px;
    font-weight: normal;
    color: #646464;
  }

  .custom-btn {
    max-height: 35px;
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 600;
    font-style: normal;
    text-align: center;
    min-height: 35px;
    padding: 8px;
  }

  .customTwoColumnGrid {
    grid-template-columns: 25% 25%;
    display: grid;
    grid-row-gap: 15px;
    grid-column-gap: 20px;
  }

  .datepicker input {
    height: 35px;
    max-height: 35px;
    min-height: 35px;
  }
  .footer-width{
  width: 87%;
}
</style>